import { render, staticRenderFns } from "./AddFundsForm.vue?vue&type=template&id=504e04d8"
import script from "./AddFundsForm.vue?vue&type=script&lang=js"
export * from "./AddFundsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports